import {store} from '../store';
import intervals from "../components/ProductPage/entrepreneur_insurance_intervals";
import {revenueToStr} from "./RevenueParser";
import {getClosestThreshold} from "./SmaffCalculations";
import history from "../router/history";

export const hasTravelInsurance = () => {
    return store.getState().productReducer.selectedSmaffPackage === 2;
};


export function isEntrepreneur() {
    return store.getState().simpleReducer.currentBusiness.type === "Entreprenad";
}


export function getBusinessName() {
    return store.getState().simpleReducer.currentBusiness.name;
}


export function getBusinessArea() {

    return store.getState().simpleReducer.company_information.business_area.name;
}

export function isAnnanVerksamhet() {

    return store.getState().simpleReducer.company_information.business_area.name === "Annan verksamhet";
}

export function getAnnanVerksamhet() {

    return store.getState().simpleReducer.company_information.other_business_type;
}

export function getBusinessType() {

    return store.getState().simpleReducer.company_information.business_type.name;
}

export function getFormattedEmployees() {

    return store.getState().simpleReducer.company_information.employees.min + "-" + store.getState().simpleReducer.company_information.employees.max;
}

export function getFormattedRevenue() {
    let revenue = store.getState().simpleReducer.company_information.revenue;

    if (!revenue.max_revenue) return revenueToStr(revenue.min_revenue) + " kr.";
    return revenueToStr(revenue.min_revenue) + " — " + revenueToStr(revenue.max_revenue) + " kr.";
}

export function getMaxRevenue() {
    let revenue = store.getState().simpleReducer.company_information.revenue;

    return revenue.max_revenue;
}

export function getPercentageOfMaxRevenueWithCurrency(percentage) {
    let revenue = store.getState().simpleReducer.company_information.revenue;

    return revenueToStr(revenue.max_revenue * percentage) + " kr.";
}


export function getPercentageOfMaxRevenueWithoutCurrency(percentage) {
    let revenue = store.getState().simpleReducer.company_information.revenue;

    return revenueToStr(revenue.max_revenue * percentage);
}


export function hasBeenDamagedWithin3Years() {

    return store.getState().simpleReducer.company_information.damaged ? "Ja" : "Nej";
}

// export function isAnnanVerksamhet() {
//     return store.getState().simpleReducer.currentBusiness.type === "Entreprenad";
// }


export function getInsuranceAmount() {

    let amount = store.getState().productReducer.insuranceAmount;

    if (amount <= 90000) return intervals[0].treshold;

    for (var i in intervals) {
        var treshold = intervals[i].treshold;
        if (treshold > amount) {
            return treshold;
        }
    }

    return "1.000.000 +";
}

export function calculateAge(dob) {
  var today = new Date();
  var dobFormat = dob.substring(0,4) + "/" + dob.substring(4,6) + "/" + dob.substring(6,8);
  var birthDate = new Date(dobFormat);  // create a date object directly from `dob1` argument
  var age_now = today.getFullYear() - birthDate.getFullYear();
  var m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) 
  {
      age_now--;
  }
  return age_now;
}

export function getFormattedInsuranceAmount() {

    let amount = store.getState().productReducer.insuranceAmount;

    if (amount <= 90000) return revenueToStr(intervals[0].treshold);

    for (var i in intervals) {
        var treshold = intervals[i].treshold;
        if (treshold > amount) {
            return revenueToStr(treshold);
            // return treshold;
        }
    }

    return "1.000.000 +";
}


function convertCompanyAddressToString(company) {

    if (company.street_address.length > 0 && company.zip_code.length > 0 && company.city.length > 0) {
        return company.street_address + ", " + company.zip_code + ", " + company.city;
    }
}

function convertAddressToString(address) {

    if (address.address.length > 0 && address.zip_code.length > 0 && address.city.length > 0) {
        return address.address + ", " + address.zip_code + ", " + address.city;
    }
}

export default function getInsurancesAddressesFromSummaryInput() {

    let arr = [];

    let summaryReducer = store.getState().summaryReducer;


    if (summaryReducer.same_as_company_address) {
        let company_information = convertCompanyAddressToString(summaryReducer.company_information);
        if (company_information) arr.push(company_information);
    } else {
        let insurance_address = convertAddressToString(summaryReducer.insurance_information.other_address);
        if (insurance_address) arr.push(insurance_address);
    }

    if (summaryReducer.secondary_insurance_address) {
        let second_address = convertAddressToString(summaryReducer.insurance_information.second_address);
        if (second_address) arr.push(second_address);
    }

    return arr;
}

export function redirectToProductFromCompanyInformation() {


    let companyReducer = store.getState().simpleReducer;

    if (isEntrepreneur()) {
        if (companyReducer.selectedRevenue.max_revenue == null) {
            history.push("/kontakt");
            return;
        }
    }

    history.push("/produkt");
    return;
}

export function hasMoreThan10MRevenue() {

    let companyReducer = store.getState().simpleReducer;

    if (companyReducer.selectedRevenue.max_revenue == null) return true;

    return false;
}

export function redirectToSummaryFromProduct() {

    let productReducer = store.getState().productReducer;

    if (!isEntrepreneur()) {
        // if (getClosestThreshold(productReducer.insuranceAmount) > 650000 || getClosestThreshold(productReducer.insuranceAmount) == null) {
        if (getClosestThreshold(productReducer.insuranceAmount) == null) {
            history.push("/kontakt");
            return;
        }
    }

    history.push("/sammanstallning");
    return;
}


export function redirectToStartIfNoBusiness() {

    let currentBusiness = store.getState().simpleReducer.currentBusiness;

    if (!currentBusiness) {
        history.push("/");
        return;
    }
}


export function hasBusiness() {

    return store.getState().simpleReducer.currentBusiness;

}
